import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../components/Component";

const WorkOrderAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Order</span>
            <span className="sub-text">
              Manage work order processes and contractor assignments
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/New-work-order`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>New Work Order</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-order-contractor-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-thumb" />
              <span>Work Order Amendment</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-order-execution`}
              onClick={() => updateSm(false)}
            >
              <Icon name="users" />
              <span>Finalized Work Orders</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/view-work-orders`}
              onClick={() => updateSm(false)}
            >
              <Icon name="activity" />
              <span>View All Work Orders</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkOrderAside;
